module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "commercialsales.54967665.svg";